import DashboardCharts from '@components/DashboardChats/DashboardCharts';
import DashboardFetchData from '@components/DashboardFetchDataComponent';
import Page from '@components/Page';
import ConfigService from '@services/global/Config';
import styled from '@src/styled-components';
import React from 'react';

import I18n from '../i18n';
import AppContext from '../services/Context';

type PropType = { history: { replace: Function }; match: any; }

type StateType = {
  isLoading: boolean;
  iconLoading?: boolean;
  userFields?: any;
  menuItems: any;
};


const percentageChartOptions = {
  maintainAspectRaio: true,
  legend: {
    display: false,
  },
  scales: {
    yAxes: [{
      ticks: {
        userCallback: function (value: any) {
          return value + "%";
        },
        beginAtZero: true,
        max: 100
      }
    }]
  }
};

const naturalNumberOptions = {
  maintainAspectRaio: true,
  scales: {
    yAxes: [{
      ticks: {
        userCallback: function (value: any) {
          return Math.floor(value)
        },
        beginAtZero: true,
        scaleOverride: true,
      }
    }]
  }
};

const naturalNumberOptionsWithoutLegend = {
  maintainAspectRaio: true,
  legend: {
    display: false,
  },
  scales: {
    yAxes: [{
      ticks: {
        userCallback: function (value: any) {
          return Math.floor(value);
        },
        stepSize: 1,
        beginAtZero: true,
        scaleOverride: true,
      }
    }]
  }
};

class Dashboard extends React.Component<PropType, StateType> {
  private _configService: ConfigService = new ConfigService();

  private idUnit: any = undefined;

  constructor(props: any) {
    super(props);
  }

  state: StateType = {
    isLoading: false,
    menuItems: undefined,
  };

  componentDidMount() {
    this.getConfig();
  }

  setUnit(unit: string) {
    this.idUnit = unit;
  }

  getConfig = async () => {
    const response = await this._configService.getGLOBAL(['userFields']);
    if (response.userFields != undefined) {
      let fields: string[] = [];

      response.userFields.map((item) => {
        fields.push(item.name ? item.name : '');
      });

      await this.setState({
        userFields: fields,
      });
    }
  }

  handleChange(value: any) {
  }

  render() {
    const {
      isLoading,
    } = this.state;

    if (!!isLoading) {
      return (
        <AppContext.Consumer>
          {({ locale, activeUnitId }) => (
            this.setUnit(activeUnitId),
            <span>{I18n.l('common.loadingTable')}</span>
          )}
        </AppContext.Consumer>
      );
    }
    return (
      <Page>
        <AppContext.Consumer>
          {({ locale, theme, activeUnitId }) => (
            this.setUnit(activeUnitId),
            <Wrapper>
              <DashboardFetchData
                title={I18n.l('dashboard.titles.doneAuditsAndGoals')}
                options={naturalNumberOptions}
              />
              <DashboardCharts
                title={I18n.l("custom.charts")}
                unit={this.idUnit}
              />
              <DashboardFetchData
                title={I18n.l('dashboard.titles.auditsWithoutAuditeds')}
                options={naturalNumberOptionsWithoutLegend}
                chartType={'bar'}
                queryAuditorGuest={true}
              />
              <DashboardFetchData
                title={I18n.l('dashboard.titles.accidentRisk')}
                options={percentageChartOptions}
                isRisk={true}
              />
              <DashboardFetchData
                title={I18n.l('dashboard.titles.customRisk')}
                options={percentageChartOptions}
                useExtraFields={true}
                selectionText={I18n.l("dashboard.subtitles.accidentChance")}
                isRisk={true}
                description={[
                  I18n.l("dashboard.texts.riskByFunctions"),
                  I18n.l("dashboard.texts.riskGenerateByField"),
                  I18n.l("dashboard.texts.whereCreateFields"),
                ]}
              />

              <DashboardFetchData
                title={I18n.l('dashboard.titles.customAudit')}
                useExtraFields={true}
                options={naturalNumberOptions}
                selectionText={I18n.l("dashboard.subtitles.auditsDone")}
                description={[
                  I18n.l("dashboard.texts.auditsByFunctions"),
                  I18n.l("dashboard.texts.auditGenerateByField"),
                  I18n.l("dashboard.texts.whereCreateFields"),
                ]}
              />

            </Wrapper>
          )}
        </AppContext.Consumer>
      </Page >
    );
  }
}

const Wrapper = styled.div`
    display: flex;
    flex-flow: column;
    align-items: flex-start;
    justify-content: flex-start;
    width: 100%;

    .main-button {
        font-weight: bold;
        text-transform: uppercase;
        font-size:15px;
    }
    .loading-more {
        margin: 15px 0;
        padding: 0;
        border: 0;
        text-align: left
    }

    .filter-group {
        margin-bottom: 50px;
    }
   
    hr{
        opacity: .6;
    }
`;


export default Dashboard;
